<template>
  <div v-on="$listeners"
       :class="$style.container"
       :style="containerStyle">
    <img :class="$style.image"
         :src="src"
         :style="style">
  </div>
</template>

<script>
  import { getPseudoClasses } from '@js/vue-style-utils'
  import { DefaultPseudoClassAttributeNames,
           DefaultPseudoClassVariableNames,
           getPseudoClassesObject,
           filterObjectByArray} from '@js/vue-style-utils'

  export default {
    name: 'BaseImage',
    inheritAttrs: false,
    props: {
      disabled: { type: Boolean, required: false, default: false },
      imageStyle: { type: Object, required: false, default: () => {}},
      src: { type: String, required: false, default: '//:0' },
    },
    data: function () {
      return {
        attributeNames: ['filter'],
        containerStyle: {
          display: 'flex',
          overflow: 'hidden',
        },
        postfixes: ['', 'hover', 'active', 'disabled'],
        style: {
          height: '100%',
          objectFit: 'cover',
          width: '100%',
        },
        variableNames: ['filter'],
      };
    },
    created: function () {
      let classObject = getPseudoClassesObject(
        this.$attrs, DefaultPseudoClassAttributeNames,
        '--base-image-container-', DefaultPseudoClassVariableNames, this.postfixes);
      let attrs = filterObjectByArray(
        this.$attrs, DefaultPseudoClassAttributeNames);

      this.containerStyle = {
        ...this.containerStyle,
        ...attrs,
        ...classObject,
      };

      classObject = getPseudoClassesObject(
        this.imageStyle, this.attributeNames,
        '--base-image-', this.variableNames, this.postfixes);
      attrs = filterObjectByArray(
        this.imageStyle, this.attributeNames);

      this.style = {
        ...this.style,
        ...attrs,
        ...classObject,
      };
    },
  };
</script>

<style lang="stylus" module>
  .container
    background-color var(--base-image-container-background-color)
    cursor var(--base-image-container-cursor)
    border var(--base-image-container-border)
    border-radius var(--base-image-container-border-radius)
    border-width var(--base-image-container-border-width)
    box-size var(--base-image-container-box-size)
    &:hover
      background-color var(--base-image-container-background-color-hover)
      cursor var(--base-image-container-cursor-hover)
      border var(--base-image-container-border-hover)
      border-radius var(--base-image-container-border-radius-hover)
      border-width var(--base-image-container-border-width-hover)
      box-size var(--base-image-container-box-size-hover)
    &:active
      background-color var(--base-image-container-background-color-active)
      cursor var(--base-image-container-cursor-active)
      border var(--base-image-container-border-active)
      border-radius var(--base-image-container-border-radius-active)
      border-width var(--base-image-container-border-width-active)
      box-size var(--base-image-container-box-size-active)
    &[disabled]
      background-color var(--base-image-container-background-color-disabled)
      cursor var(--base-image-container-cursor-disabled)
      border var(--base-image-container-border-disabled)
      border-radius var(--base-image-container-border-radius-disabled)
      border-width var(--base-image-container-border-width-disabled)
      box-size var(--base-image-container-box-size-disabled)

  .image
    filter var(--base-image-filter)
    &:hover
      filter var(--base-image-filter-hover)
    &:active
      filter var(--base-image-filter-active)
    &[disabled]
      filter var(--base-image-filter-disabled)
</style>
